/* Mama Jewels DE – "Passende Kette hinzufügen" (collier-kiezer onder hangers, Duitse versie: cm, EUR, native optie "Karat")
   Bron van waarheid = de echte Shopify-varianten in de JSON (kleur + karaat + stijl + lengte -> variant-ID).
   Een combinatie die niet bestaat kan nooit in het mandje komen.
   Geen eigen koopknop: met het vinkje gaat de ketting mee met de hoofdknop "Add to cart".
   De hoofdknop (en Globo) blijven onaangeroerd; pas als de hanger gelukt is in het mandje, voegen we de ketting toe. */

// Luistert mee (zonder iets te veranderen) naar geslaagde /cart/add-verzoeken van thema of Globo
if (!window.mjGcCartHook) {
  window.mjGcCartHook = true;
  const isAdd = (url, method) => /\/cart\/add/.test(String(url || '')) && String(method || 'GET').toUpperCase() === 'POST';
  const notify = () => setTimeout(() => document.dispatchEvent(new CustomEvent('mj-gc:main-added')), 0);
  const origFetch = window.fetch;
  window.fetch = function (input, init) {
    const url = typeof input === 'string' ? input : (input && input.url);
    const method = (init && init.method) || (input && input.method);
    const ours = init && init.headers && (init.headers['X-MJ-GC'] || (init.headers.get && init.headers.get('X-MJ-GC')));
    const p = origFetch.apply(this, arguments);
    if (!ours && isAdd(url, method)) p.then((r) => { if (r && r.ok) notify(); }).catch(() => {});
    return p;
  };
  const origOpen = XMLHttpRequest.prototype.open;
  const origSend = XMLHttpRequest.prototype.send;
  XMLHttpRequest.prototype.open = function (method, url) { this.mjGcAdd = isAdd(url, method); return origOpen.apply(this, arguments); };
  XMLHttpRequest.prototype.send = function () {
    if (this.mjGcAdd) this.addEventListener('load', () => { if (this.status >= 200 && this.status < 300) notify(); });
    return origSend.apply(this, arguments);
  };
}

// DE: karaat is een native variantoptie "Karat" (Dawn 8: radios name="Karat", selects name="options[Karat]"); fallback Globo-velden
var MJ_GC_KARAT_NATIVE = 'input[name="Karat"], select[name="options[Karat]"], select[name="Karat"], input[name="Goldlegierung"], select[name="options[Goldlegierung]"], select[name="Goldlegierung"]';
var MJ_GC_KARAT_FALLBACK = '.gpo-element input[name*="karat" i], .gpo-element select[name*="karat" i], .gpo-element input[name*="gehalt" i], .gpo-element select[name*="gehalt" i], input[name*="Gold Karat" i], select[name*="Gold Karat" i], .gpo-element input[name*="legierung" i], .gpo-element select[name*="legierung" i]';

if (!customElements.get('mj-gold-chain')) {
  customElements.define('mj-gold-chain', class MjGoldChain extends HTMLElement {
    connectedCallback() {
      // Wordt opnieuw aangeroepen als we het blok verplaatsen; maar één keer opbouwen
      if (this.mjReady) return;
      this.mjReady = true;
      try {
        this.variants = JSON.parse(this.querySelector('[data-mj-gc-data]').textContent);
      } catch (e) { this.variants = []; }
      if (!this.variants.length) { this.remove(); return; }

      this.karats = ['9K', '14K', '18K'];
      // Zilver: alleen Klassisch en Statement
      this.styles = this.dataset.mode === 'silver' ? ['classic', 'statement'] : ['delicate', 'classic', 'statement'];
      // Lengtes komen uit de echte varianten (goud 42/45/50, zilver 38 t/m 60)
      this.lengths = [...new Set(this.variants.map((v) => v.length))].sort((a, b) => a - b);
      // Bedels (mode charm) werken als zilver: alleen een maat kiezen, maar dan een bedelarmband
      this.charm = this.dataset.mode === 'charm';
      this.silver = this.dataset.mode === 'silver' || this.charm;
      this.parentLabel = this.dataset.parent || 'Anhänger';
      this.itemName = this.dataset.itemName || (this.silver ? 'Silberkette' : 'Goldkette');
      this.popularLength = this.dataset.popular || '45';
      this.defaults = { karat: '14K', style: 'classic', length: this.popularLength };
      this.styleInfo = {
        delicate: { name: 'Fein', note: 'Zart & elegant', mm: '1,2' },
        classic: { name: 'Klassisch', note: 'Zeitlos & vielseitig', mm: '1,4' },
        statement: { name: 'Statement', note: 'Voller & markanter', mm: '1,7' }
      };
      this.karatNote = { '9K': 'Am günstigsten', '14K': 'Am beliebtesten', '18K': 'Sattester Goldton' };
      this.colorNames = { yellow: 'Gelbgold', white: 'Weißgold', rose: 'Roségold' };
      // DE: lengtes alleen in cm (geen inches)
      this.state = Object.assign({ color: this.readPendantColor() }, this.defaults);
      // Karaat van de ketting standaard gelijk aan dat van de hanger (DE: native variantoptie "Karat", fallback Globo-veld)
      this.pendantKarat = this.readPendantKarat();
      if (this.pendantKarat) this.state.karat = this.pendantKarat;
      this.tab = 'classic';
      this.ltab = this.popularLength;

      this.panel = this.querySelector('[data-mj-gc-panel]');
      this.checkEl = this.querySelector('[data-mj-gc-check]');
      this.selected = false;
      this.noticeEl = this.querySelector('[data-mj-gc-notice]');

      this.querySelectorAll('[data-mj-gc-toggle]').forEach((b) => b.addEventListener('click', () => this.toggle()));
      // Aanklikken = standaardketting meteen erin én de kiezer open om iets anders te kiezen; uitvinken = dicht
      this.checkEl.addEventListener('change', () => {
        this.selected = this.checkEl.checked;
        this.toggle(this.selected);
        this.render();
      });
      try { this.pimgs = JSON.parse(this.querySelector('[data-mj-gc-pimgs]').textContent); } catch (e) { this.pimgs = {}; }
      this.addEventListener('click', (e) => {
        const opt = e.target.closest('[data-mj-gc-value]');
        if (opt && !opt.disabled) { this.choose(opt.dataset.group, opt.dataset.mjGcValue); return; }
        if (e.target.closest('[data-mj-gc-back]')) { this.csingle = null; this.renderCompare(); return; }
        const tab = e.target.closest('[data-mj-gc-tab]');
        if (tab) {
          // Klick = nur diese Kette im Vergleichsbild; erneuter Klick = wieder alle Ketten
          const st = tab.dataset.mjGcTab;
          this.csingle = this.csingle === st ? null : st;
          this.tab = st;
          this.renderCompare();
          return;
        }
        const ltab = e.target.closest('[data-mj-gc-ltab]');
        if (ltab) {
          // Klick = Foto nur dieser Kette; erneuter Klick auf dieselbe Länge = wieder alle drei
          const l = ltab.dataset.mjGcLtab;
          this.lsingle = this.lsingle === l ? null : l;
          this.showLength(l);
          return;
        }
        const open = e.target.closest('[data-mj-gc-open]');
        if (open) { this.openModal(open.dataset.mjGcOpen); return; }
        if (e.target.closest('[data-mj-gc-close]')) { e.target.closest('dialog').close(); }
      });
      this.querySelectorAll('dialog').forEach((d) => d.addEventListener('click', (e) => { if (e.target === d) d.close(); }));
      const tabs = this.querySelector('[data-mj-gc-tabs]');
      if (tabs) tabs.addEventListener('keydown', (e) => this.onTabKey(e));
      const ltabs = this.querySelector('[data-mj-gc-ltabs]');
      if (ltabs) ltabs.addEventListener('keydown', (e) => {
        if (!['ArrowLeft', 'ArrowRight'].includes(e.key)) return;
        const i = this.lengths.indexOf(this.ltab) + (e.key === 'ArrowRight' ? 1 : -1);
        const nl = this.lengths[(i + this.lengths.length) % this.lengths.length];
        this.lsingle = nl;
        this.showLength(nl, true);
      });

      // Kleur van de hanger volgen als de klant een andere kleur kiest
      document.addEventListener('change', (e) => {
        if (!e.target.closest('variant-radios, variant-selects, .product-form__input')) return;
        setTimeout(() => {
          this.updatePendantImg();
          const c = this.readPendantColor();
          if (c !== this.state.color) { this.state.color = c; this.render(this.normalize()); }
        }, 0);
      });
      document.addEventListener('change', (e) => {
        if (!e.target.matches || !e.target.matches(MJ_GC_KARAT_NATIVE + ', ' + MJ_GC_KARAT_FALLBACK)) return;
        setTimeout(() => this.syncPendantKarat(), 0);
      });
      // Klik op de balk (naast de link) werkt ook als aan/uit
      const bar = this.querySelector('.mj-gc__bar');
      if (bar) bar.addEventListener('click', (e) => { if (!e.target.closest('button')) this.checkEl.click(); });
      if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') subscribe(PUB_SUB_EVENTS.variantChange, () => setTimeout(() => this.updatePendantImg(), 0));

      this.setupBundle();
      this.updatePendantImg();
      this.normalize();
      this.render();
      this.classList.add('is-ready');
    }

    // Blok vlak boven de hoofdknop zetten (na de Globo-opties) en de hoofdknop volgen
    setupBundle() {
      const info = this.closest('.product__info-container') || document;
      this.mainBtn = info.querySelector('product-form .product-form__submit');
      this.priceEl = info.querySelector('[id^="price-"]');
      info.classList && info.classList.add('mj-gc-on');
      if (!this.mainBtn) return;
      this.noteEl = info.querySelector('.mj-sizer-note');
      this.form = this.mainBtn.closest('product-form') || this.mainBtn.parentElement;
      this.place();
      // Globo zet zijn opties pas later boven de knop (en maakt soms een kopie van de knop); dan schuiven wij weer vlak erboven
      new MutationObserver(() => { this.place(); clearTimeout(this.placeT); this.placeT = setTimeout(() => { this.place(); this.syncPendantKarat(); this.renderTotal(); }, 80); })
        .observe(this.mainBtn.parentElement, { childList: true, attributes: true, attributeFilter: ['class', 'style'], subtree: true });

      // Alleen een klik op de hoofdknop (of de Globo-kopie ervan) "wapent" het meesturen van de ketting
      document.addEventListener('click', (e) => {
        const b = e.target.closest && e.target.closest('.product-form__submit');
        if (b && this.form.contains(b)) this.armed = Date.now();
      }, true);
      document.addEventListener('mj-gc:main-added', () => {
        if (!this.selected || !this.armed || Date.now() - this.armed > 15000) return;
        this.armed = 0;
        // Direct: bij Globo-extra's springt de pagina meteen naar /cart
        this.addChain();
      });
      const upd = () => this.renderTotal();
      if (this.priceEl) new MutationObserver(upd).observe(this.priceEl, { childList: true, subtree: true, characterData: true });
      const gpo = document.querySelector('.gpo-total');
      if (gpo) new MutationObserver(upd).observe(gpo, { childList: true, subtree: true, characterData: true, attributes: true });
    }

    // Foto van de gekozen hangervariant in het kaartje
    updatePendantImg() {
      const img = this.querySelector('[data-mj-gc-pimg]');
      const input = this.form && this.form.querySelector('input[name="id"]');
      const src = input && this.pimgs[input.value];
      if (img && src && img.getAttribute('src') !== src) img.setAttribute('src', src);
    }

    // Volgorde vlak boven de hoofdknop: notitie, kiezer
    place() {
      // De zichtbare koopknop: Globo verbergt soms het origineel en toont een kopie
      const btns = [...this.form.querySelectorAll('.product-form__submit')];
      const btn = btns.find((b) => b.offsetParent !== null) || this.mainBtn;
      if (!btn || !btn.parentElement) return;
      const ok = btn.previousElementSibling === this && (!this.noteEl || this.previousElementSibling === this.noteEl);
      if (!ok) btn.before(...[this.noteEl, this].filter(Boolean));
    }

    // "1.234,00 €", "489 €", "15,00" en "$1,234.00" -> centen. Laatste scheidingsteken met precies 3 cijfers erna = duizendtal.
    cents(text) {
      let t = String(text || '').replace(/[^0-9.,]/g, '');
      const dec = Math.max(t.lastIndexOf(','), t.lastIndexOf('.'));
      if (dec > -1 && t.length - dec - 1 !== 3) t = t.slice(0, dec).replace(/[.,]/g, '') + '.' + t.slice(dec + 1);
      else t = t.replace(/[.,]/g, '');
      const n = parseFloat(t);
      return isNaN(n) ? null : Math.round(n * 100);
    }

    pendantPrice() {
      if (!this.priceEl) return null;
      const cands = [...this.priceEl.querySelectorAll('.price__sale .price-item--sale, .price__regular .price-item--regular')];
      const el = cands.find((e) => e.offsetParent !== null) || cands[0];
      // Globo telt zijn extra's (glitter, gravure) al op in deze getoonde prijs
      return el ? this.cents(el.textContent) : null;
    }

    // Globo-extra's die de klant gekozen heeft (Einschluss, Glitzerpulver, Blattgold, Gravur, ...), elk met hun meerprijs.
    // Karaat hoort bij de hanger zelf en blijft in de hangerprijs.
    extras() {
      const out = [];
      // "(+ 15,00 €)" of "(+€15)"
      const priceOf = (t) => { const m = String(t || '').match(/\(\s*\+\s*[^\d()]*([\d.,]+)[^()]*\)/); return m ? this.cents(m[1]) : 0; };
      const clean = (t) => String(t || '').replace(/\s+/g, ' ').replace(/\(.*$/, '').trim();
      (this.form || document).querySelectorAll('.gpo-element').forEach((el) => {
        if (!el.offsetParent) return;
        const labEl = el.querySelector('.gpo-label');
        const lab = labEl ? labEl.textContent.replace(/\s+/g, ' ').trim() : '';
        if (/karat|gehalt|legierung/i.test(lab)) return;
        const nameOf = (opt) => {
          if (/gravur|engrav/i.test(lab)) return 'Gravur';
          if (/glitzer|glitter|shimmer/i.test(lab)) return 'Glitzerpulver';
          if (/blattgold|goldflock|gold ?flake/i.test(lab)) return 'Blattgold';
          if (/einschluss|inclusion/i.test(lab) && opt) return opt;
          return clean(lab).replace(/^add\s+(an?\s+)?/i, '').replace(/\s*hinzufügen\s*:?$/i, '').replace(/:$/, '').trim() || opt || 'Option';
        };
        el.querySelectorAll('select').forEach((s) => {
          const o = s.options[s.selectedIndex];
          if (!o || !o.value) return;
          const c = priceOf(o.text);
          if (c) out.push({ name: nameOf(clean(o.text)), cents: c });
        });
        el.querySelectorAll('input[type="checkbox"]:checked, input[type="radio"]:checked').forEach((i) => {
          const l = i.closest('label');
          const c = priceOf(l && l.textContent) || priceOf(lab);
          if (c) out.push({ name: nameOf(clean(l && l.textContent)), cents: c });
        });
      });
      return out;
    }

    // Uit: "+$778" naast de link; aan: prijsopbouw hanger + extra opties + ketting = totaal, en het totaal in de hoofdknop.
    // Globo's eigen regel "Selections will add ..." wordt dan verborgen: de extra's staan in dit overzicht.
    renderTotal() {
      const v = this.current();
      const p = this.pendantPrice();
      const on = !!(this.selected && v && p !== null);
      const total = on ? this.money(p + v.price) : '';
      const sum = this.querySelector('[data-mj-gc-total]');
      if (sum) { const t = !on && v ? `+${this.money(v.price)}` : ''; if (sum.textContent !== t) sum.textContent = t; }
      const bd = this.querySelector('[data-mj-gc-breakdown]');
      if (bd) {
        let html = '';
        if (on) {
          const ex = this.extras();
          const exSum = ex.reduce((a, x) => a + x.cents, 0);
          // de getoonde prijs bevat de Globo-extra's al; de hanger zelf = prijs min de extra's
          const base = exSum && exSum < p ? p - exSum : p;
          const rows = exSum && exSum < p ? ex.map((x) => `<div class="is-extra"><span>${x.name}</span><span>+${this.money(x.cents)}</span></div>`).join('') : '';
          // "9K Anhänger" / "14K Charm": karaat van de hanger/bedel uit de native optie "Karat" (zilver: geen karaat)
          const km = this.karatOfPendant();
          const plabel = km ? `${this.parentLabel} ${this.fine(km)} Gold` : this.parentLabel;
          html = `<div><span>${plabel}</span><span>${this.money(base)}</span></div>${rows}<div><span>${this.dataset.mode === 'silver' ? `${this.itemName} (${this.styleName(this.state.style)}, ${this.cm(this.state.length)})` : this.itemName}</span><span>+${this.money(v.price)}</span></div><div class="is-total"><span>Gesamt</span><span>${total}</span></div>`;
        }
        if (this.bdHtml !== html) { this.bdHtml = html; bd.innerHTML = html; }
        if (bd.hidden === on) bd.hidden = !on;
      }
      const info = this.closest('.product__info-container') || document.body;
      info.classList.toggle('mj-gc-bd-on', on);
      if (!this.form) return;
      this.form.querySelectorAll('.product-form__submit').forEach((b) => {
        let t = b.querySelector('.mj-gc-btn-total');
        if (!t && !on) return;
        if (!t) {
          t = document.createElement('span');
          t.className = 'mj-gc-btn-total';
          const first = b.querySelector('span');
          if (first) first.after(t); else b.append(t);
        }
        const txt = on ? `· ${total}` : '';
        if (t.textContent !== txt) t.textContent = txt;
      });
    }

    // Globo laadt zijn opties later dan dit blok: karaat van de hanger opnieuw ophalen zodra het er is
    syncPendantKarat() {
      const k = this.readPendantKarat();
      if (!k || k === this.pendantKarat) return;
      this.pendantKarat = k;
      if (!this.karatTouched) { this.state.karat = k; this.render(this.normalize()); } else this.render();
    }

    readPendantKarat() {
      // Zilveren ketting/armband: karaat van de hanger/bedel doet er niet toe
      if (this.silver) return null;
      return this.karatOfPendant();
    }

    // Karaat van de hanger/bedel als "9K" / "14K" / "18K".
    // DE: native variantoptie "Karat" ("14 Karat"; radios name="Karat", selects name="options[Karat]");
    // fallback: Globo-veld met 'Karat' of 'Gehalt' in de naam.
    karatOfPendant() {
      const scope = this.closest('.product__info-container') || document;
      const pick = (sel) => {
        for (const root of [scope, document]) {
          const el = [...root.querySelectorAll(sel)].find((x) => !x.closest('mj-gold-chain') && (x.tagName === 'SELECT' || x.checked));
          if (el) return el;
        }
        return null;
      };
      const el = pick(MJ_GC_KARAT_NATIVE) || pick(MJ_GC_KARAT_FALLBACK);
      const val = el ? String(el.value) : '';
      const m = val.match(/(9|14|18)\s*(K|kt|karat)/i);
      if (m) return `${m[1]}K`;
      // "375 / 585 / 750 Gold" (Feingehalt)
      const f = val.match(/\b(375|585|750)\b/);
      return f ? { 375: '9K', 585: '14K', 750: '18K' }[f[1]] : null;
    }

    // Prijsverschil t.o.v. de huidige keuze: "+120 €", "−80 €" of "Inklusive"
    diff(d) {
      if (!d) return 'Inklusive';
      return d > 0 ? `+${this.money(d)}` : `−${this.money(-d)}`;
    }

    readPendantColor() {
      if (this.silver) return 'silver';
      const scope = this.closest('.product__info-container') || document;
      // DE: optie "Farbe" met Gelbgold / Weißgold / Roségold
      const picked = [...scope.querySelectorAll('variant-radios input:checked, variant-selects select, .product-form__input input:checked')]
        .map((i) => (i.value || '').toLowerCase()).join(' ');
      if (picked.includes('weiß') || picked.includes('weiss') || picked.includes('white')) return 'white';
      if (picked.includes('rosé') || picked.includes('rose')) return 'rose';
      return 'yellow';
    }

    find(q) {
      return this.variants.filter((v) => Object.keys(q).every((k) => v[k] === q[k]));
    }

    minPrice(list) {
      return list.length ? Math.min(...list.map((v) => v.price)) : null;
    }

    money(cents, short) {
      const cur = this.dataset.currency || (window.Shopify && Shopify.currency && Shopify.currency.active) || 'EUR';
      const opts = { style: 'currency', currency: cur };
      // Hele euro's zonder ",00" ("489 €")
      if (cents % 100 === 0) { opts.minimumFractionDigits = 0; opts.maximumFractionDigits = 0; }
      try {
        return new Intl.NumberFormat(this.dataset.locale || 'de-DE', opts).format(cents / 100);
      } catch (e) { return (cents / 100).toFixed(2) + ' ' + cur; }
    }

    // Echte leveranciersfoto als herhalende strook; hoogte = tegelhoogte x schaal, dus 1.2 / 1.4 / 1.7 mm blijven in verhouding
    chain(v, scale) {
      if (!v) return '';
      const h = (v.th / 2) * scale;
      const w = (v.tw / 2) * scale;
      return `<span class="mj-gc__chain mj-gc__chain--${v.color}" style="background-image:url('${v.tile}');background-size:${w}px ${h}px;height:${h}px"></span>`;
    }

    // Referentievariant voor een beeld: dezelfde kleur/karaat/stijl, anders 14K geel van die stijl
    ref(color, karat, style) {
      return this.find({ color, karat, style })[0] || this.find({ color, style })[0] || this.find({ color: 'yellow', karat: '14K', style })[0];
    }

    styleName(st) { return this.styleInfo[st].name; }

    choose(group, value) {
      this.state[group] = value;
      if (group === 'karat') this.karatTouched = true;
      // Wie in de kiezer iets kiest, wil de ketting: vinkje gaat vanzelf aan (uitvinken blijft mogelijk)
      if (!this.selected) { this.selected = true; this.checkEl.checked = true; }
      this.render(this.normalize(group));
    }

    // Maakt een ongeldige combinatie geldig volgens vaste regels en geeft een zichtbare melding terug
    normalize(changed) {
      const s = this.state;
      const notes = [];
      if (!this.find({ color: s.color }).length) s.color = this.find({ color: 'yellow' }).length ? 'yellow' : this.variants[0].color;
      if (!this.find({ color: s.color, karat: s.karat }).length) {
        s.karat = this.find({ color: s.color, karat: this.defaults.karat }).length ? this.defaults.karat : this.find({ color: s.color })[0].karat;
      }
      if (!this.find({ color: s.color, karat: s.karat, style: s.style }).length) {
        const was = s.style;
        const order = [this.defaults.style, 'delicate', 'classic', 'statement'];
        s.style = order.find((st) => this.find({ color: s.color, karat: s.karat, style: st }).length);
        if (changed) notes.push(`${this.styleName(was)} ist in ${this.combo(s.karat, s.color)} nicht erhältlich, daher haben wir ${this.styleName(s.style)} gewählt.`);
      }
      if (!this.find({ color: s.color, karat: s.karat, style: s.style, length: s.length }).length) {
        const was = s.length;
        const l = this.find({ color: s.color, karat: s.karat, style: s.style });
        s.length = (l.find((v) => v.length === this.popularLength) || l[0]).length;
        if (changed) notes.push(this.silver
          ? `${was} cm ist nicht erhältlich, daher haben wir ${s.length} cm gewählt.`
          : `${was} cm ist in ${this.combo(s.karat, s.color)} ${this.styleName(s.style)} nicht erhältlich, daher haben wir ${s.length} cm gewählt.`);
      }
      return notes;
    }

    // DE: Feingehalt zoals Duitse juweliers het noemen ("585 Gold" i.p.v. "14K")
    fine(karat) {
      return { '9K': '375', '14K': '585', '18K': '750' }[karat] || karat;
    }

    combo(karat, color) {
      return color === 'yellow' ? `${this.fine(karat)} Gold` : `${this.fine(karat)} ${this.colorNames[color]}`;
    }

    render(notes) {
      const s = this.state;

      // Kaartje: uit = "Passende Kette hinzufügen", aan = "Kette hinzugefügt"
      const cur = this.current();
      const on = !!(this.selected && cur);
      this.classList.toggle('is-selected', on);
      // Kleur van het getekende kettinkje in het fotovakje
      this.style.setProperty('--gc-chain', { yellow: '#C9A14F', white: '#B7BAC0', rose: '#C8927F', silver: '#A8ACB3' }[s.color] || '#C9A14F');
      this.querySelector('.mj-gc__card-title').textContent = this.charm ? (on ? 'Armband hinzugefügt' : 'Charm-Armband hinzufügen') : (on ? 'Kette hinzugefügt' : 'Passende Kette hinzufügen');
      this.querySelector('[data-mj-gc-cardsub]').textContent = !on && this.added ? `In den Warenkorb gelegt ✓ · ${this.added}` : this.label();

      // Gold purity (alleen bij goud)
      const karatEl = this.querySelector('[data-mj-gc-group="karat"]');
      if (karatEl) karatEl.innerHTML = this.karats.map((k) => {
        const list = this.find({ color: s.color, karat: k });
        const on = s.karat === k;
        // Echte prijs voor de huidige stijl + lengte in dit karaat (anders "From")
        const same = this.find({ color: s.color, karat: k, style: s.style, length: s.length })[0];
        const priceTxt = same ? this.money(same.price) : (list.length ? 'Ab ' + this.money(this.minPrice(list)) : 'Nur in Gelbgold');
        const note = this.pendantKarat === k ? (this.charm ? 'Passt zu Ihrem Charm' : 'Passt zu Ihrem Anhänger') : (this.karatNote[k] || '');
        return `<button type="button" class="mj-gc__opt mj-gc__opt--karat${on ? ' is-on' : ''}" data-group="karat" data-mj-gc-value="${k}" aria-pressed="${on}" ${list.length ? '' : 'disabled'}>
          <span class="mj-gc__opt-name">${this.fine(k)} Gold</span>
          <span class="mj-gc__opt-sub mj-gc__opt-note${this.pendantKarat === k ? ' mj-gc__opt-match' : ''}">${note}</span>
          <span class="mj-gc__opt-sub mj-gc__opt-price">${priceTxt}</span>
        </button>`;
      }).join('');

      // Chain style: altijd drie kaarten, niet-bestaande combinaties uitgeschakeld (alleen bij goud)
      const styleEl = this.querySelector('[data-mj-gc-group="style"]');
      if (styleEl) styleEl.innerHTML = this.styles.map((st) => {
        const list = this.find({ color: s.color, karat: s.karat, style: st });
        const on = s.style === st;
        const info = this.styleInfo[st];
        const vv = this.find({ color: s.color, karat: s.karat, style: st, length: s.length })[0];
        const dTxt = vv && cur ? this.diff(vv.price - cur.price) : '';
        return `<button type="button" class="mj-gc__opt mj-gc__opt--style${on ? ' is-on' : ''}" data-group="style" data-mj-gc-value="${st}" aria-pressed="${on}" ${list.length ? '' : 'disabled'}>
          <span class="mj-gc__opt-img mj-gc__opt-img--zoom${this.photo(st) ? ' mj-gc__opt-img--photo' : ''}">${this.photo(st) ? `<img src="${this.photo(st)}" alt="" loading="lazy">` : this.chain(list[0] || this.ref(s.color, s.karat, st), 3)}</span>
          <span class="mj-gc__opt-name">${info.name}</span>
          <span class="mj-gc__opt-sub">~ ${this.mm(st, list[0])} mm</span>
          <span class="mj-gc__opt-sub ${list.length ? 'mj-gc__opt-diff' : 'mj-gc__opt-note'}">${list.length ? dTxt : 'Nicht erhältlich in ' + this.combo(s.karat, s.color)}</span>
        </button>`;
      }).join('');

      // Length
      this.querySelector('[data-mj-gc-group="length"]').innerHTML = this.lengths.map((l) => {
        const ok = this.find({ color: s.color, karat: s.karat, style: s.style, length: l }).length;
        const on = s.length === l;
        const lv = this.find({ color: s.color, karat: s.karat, style: s.style, length: l })[0];
        const sub = !ok ? '<span class="mj-gc__opt-sub">Nicht verfügbar</span>'
          : `<span class="mj-gc__opt-sub mj-gc__opt-diff">${cur && !(this.charm && lv.price === cur.price) ? this.diff(lv.price - cur.price) : ''}</span>${l === this.popularLength ? '<span class="mj-gc__opt-sub mj-gc__opt-pop">Am beliebtesten</span>' : ''}`;
        return `<button type="button" class="mj-gc__opt mj-gc__opt--pill${on ? ' is-on' : ''}" data-group="length" data-mj-gc-value="${l}" aria-pressed="${on}" ${ok ? '' : 'disabled'}><span class="mj-gc__opt-name">${this.cm(l)}</span>${sub}</button>`;
      }).join('');

      // Melding bij automatische aanpassing
      if (Array.isArray(notes)) {
        this.noticeEl.textContent = notes.join(' ');
        this.noticeEl.hidden = !notes.length;
      }

      // Vinkje alleen bruikbaar als de combinatie bestaat
      const v = this.current();
      this.checkEl.disabled = !v;
      if (!v) { this.checkEl.checked = false; this.selected = false; }

      this.renderCompare();
      this.renderTotal();
    }

    // Breedte uit het product (18K Klassisch is 1,3 mm); Duitse decimale komma
    mm(style, v) {
      const w = v && v.width ? parseFloat(String(v.width).replace(',', '.')) : NaN;
      return isNaN(w) ? this.styleInfo[style].mm : w.toFixed(1).replace('.', ',');
    }

    // Foto der Kettenart (nur Gelbgold; Fotos kommen als data-photo-* aus dem Snippet)
    photo(st) {
      const m = this.dataset.mode;
      if (!((m === 'gold' && this.state.color === 'yellow') || m === 'silver')) return '';
      return this.dataset['photo' + st.charAt(0).toUpperCase() + st.slice(1)] || '';
    }

    renderCompare() {
      const tabs = this.querySelector('[data-mj-gc-tabs]');
      if (!tabs) return;
      const s = this.state;
      // Mit echten Fotos: beim Öffnen ist kein Stil gewählt (alle Ketten sichtbar)
      const photoMode = !!this.photo('classic');
      tabs.innerHTML = this.styles.map((st) => {
        const on = photoMode ? this.csingle === st : this.tab === st;
        const v = this.ref(s.color, s.karat, st);
        return `<button type="button" role="tab" class="mj-gc__tab${on ? ' is-on' : ''}" aria-selected="${on}" tabindex="${on ? 0 : -1}" data-mj-gc-tab="${st}">
          <span class="mj-gc__tab-name">${this.styleName(st)}</span><span class="mj-gc__tab-mm">${this.mm(st, v)} mm</span></button>`;
      }).join('');
      const cur = this.ref(s.color, s.karat, this.tab);
      const ph = this.photo(this.tab);
      const stage = this.querySelector('[data-mj-gc-stage]');
      stage.classList.toggle('mj-gc__stage--chainphoto', !!ph);
      // Mit echten Fotos: keine vergrößerte Ansicht mehr, nur das Vergleichsbild + Hals
      stage.hidden = !!ph;
      stage.innerHTML = ph
        ? `<span class="mj-gc__zoom-badge">Vergrößerte Ansicht</span><img class="mj-gc__stage-photo" src="${ph}" alt="${this.styleName(this.tab)}, vergrößert">`
        : `${this.chain(cur, 2.2)}<p class="mj-gc__stage-note">${this.styleInfo[this.tab].note}</p>`;
      // Gewählter Stil am Hals (45 cm)
      const neck = this.querySelector('[data-mj-gc-neck]');
      if (neck) {
        const key = 'neck' + this.tab.charAt(0).toUpperCase() + this.tab.slice(1);
        // Beim Öffnen: alle Stile zusammen am Hals; nach Klick nur der gewählte Stil
        const nsrc = ph ? (this.csingle ? this.dataset[key] : (this.dataset.neckAll || '')) : '';
        neck.hidden = !nsrc;
        if (nsrc) {
          const mm = this.styleInfo[this.tab].mm;
          neck.querySelector('[data-mj-gc-neck-title]').textContent = this.csingle
            ? `${mm} mm · getragen in 45 cm Länge`
            : `${this.styles.map((x) => this.styleInfo[x].mm).join(' · ')} mm am Hals`;
          neck.querySelector('[data-mj-gc-neck-sub]').textContent = '';
          const ni = neck.querySelector('[data-mj-gc-neck-img]');
          if (ni.getAttribute('src') !== nsrc) ni.setAttribute('src', nsrc);
          ni.alt = this.csingle ? `${this.styleName(this.tab)} ${mm} mm, 45 cm am Hals` : 'Alle Kettenstile zusammen am Hals';
        }
      }
      // Vergleichsbild nur bei Gelbgold; sonst die gezeichneten Ketten
      const cmp = this.querySelector('[data-mj-gc-compare]');
      const scaleEl = this.querySelector('[data-mj-gc-scale]');
      const usePhoto = !!(cmp && this.photo('classic'));
      if (cmp) cmp.hidden = !usePhoto;
      const cimg = cmp && cmp.querySelector('[data-mj-gc-cmpimg]');
      if (cimg) {
        const all = cimg.getAttribute('data-src-all');
        const src = (this.csingle && cimg.getAttribute('data-src-' + this.csingle)) || all;
        if (!cimg.dataset.mjFallback) {
          cimg.dataset.mjFallback = '1';
          cimg.addEventListener('error', () => { if (cimg.getAttribute('src') !== all) cimg.src = all; });
        }
        if (cimg.getAttribute('src') !== src) cimg.setAttribute('src', src);
        cimg.alt = this.csingle ? `${this.styleName(this.csingle)} ${this.styleInfo[this.csingle].mm} mm` : (cimg.dataset.altAll || (cimg.dataset.altAll = cimg.alt));
      }
      const note = this.querySelector('[data-mj-gc-scale-note]');
      if (cmp) cmp.classList.toggle('is-single', !!(usePhoto && this.csingle));
      const cap = this.querySelector('[data-mj-gc-single-cap]');
      if (cap) {
        cap.hidden = !(usePhoto && this.csingle);
        if (this.csingle) cap.innerHTML = `${this.styleInfo[this.csingle].mm} mm <span>· ${this.styleName(this.csingle)}</span>`;
      }
      if (note) note.hidden = !!(usePhoto && this.csingle);
      const back = this.querySelector('[data-mj-gc-back-wrap]');
      if (back) back.hidden = !(usePhoto && this.csingle);
      if (scaleEl) scaleEl.hidden = usePhoto;
      this.querySelector('[data-mj-gc-scale]').innerHTML = this.styles.map((st) => {
        const v = this.ref(s.color, s.karat, st);
        return `<div class="mj-gc__scale-row${this.tab === st ? ' is-on' : ''}"><span class="mj-gc__scale-name">${this.styleName(st)}</span>${this.chain(v, 1.3)}</div>`;
      }).join('');
    }

    onTabKey(e) {
      if (!['ArrowLeft', 'ArrowRight'].includes(e.key)) return;
      const i = this.styles.indexOf(this.tab) + (e.key === 'ArrowRight' ? 1 : -1);
      this.tab = this.styles[(i + this.styles.length) % this.styles.length];
      if (this.photo('classic')) this.csingle = this.tab;
      this.renderCompare();
      this.querySelector(`[data-mj-gc-tab="${this.tab}"]`).focus();
    }

    // Lengtevenster: knop bovenin kiest welke foto eronder staat
    showLength(l, focus) {
      this.ltab = l;
      this.querySelectorAll('[data-mj-gc-ltab]').forEach((b) => {
        const on = b.dataset.mjGcLtab === l;
        b.classList.toggle('is-on', on);
        b.setAttribute('aria-selected', on);
        b.tabIndex = on ? 0 : -1;
        if (on && focus) b.focus();
      });
      this.querySelectorAll('[data-mj-gc-lrow]').forEach((r) => r.classList.toggle('is-on', r.dataset.mjGcLrow === l));
      const img = this.querySelector('[data-mj-gc-lphoto]');
      if (!img) return;
      let all = img.getAttribute('data-src-all') || img.src;
      // Zilver: geen foto met alle drie; standaard = gekozen stijl op de gekozen lengte
      if (this.dataset.mode === 'silver') all = img.getAttribute('data-src-' + this.state.style + '-' + this.state.length) || all;
      // Einzelfoto passend zum gewählten Kettenstil (Gold), sonst je Länge
      const src = (this.lsingle && (img.getAttribute('data-src-' + this.state.style + '-' + this.lsingle) || img.getAttribute('data-src-' + this.lsingle))) || all;
      // Fehlt das Einzelfoto (noch nicht hochgeladen), bleibt das Foto mit allen drei Längen
      if (!img.dataset.mjFallback) {
        img.dataset.mjFallback = '1';
        img.addEventListener('error', () => { if (img.getAttribute('src') !== all) { img.src = all; img.classList.remove('is-fading'); } });
      }
      img.alt = this.charm ? `Armband in ${l} cm` : (this.lsingle ? `Kette in ${l} cm Länge am Hals` : (img.dataset.altAll || img.alt));
      if (img.getAttribute('src') !== src) {
        img.classList.add('is-fading');
        setTimeout(() => { img.src = src; img.classList.remove('is-fading'); }, 150);
      }
    }

    current() {
      const s = this.state;
      return this.find({ color: s.color, karat: s.karat, style: s.style, length: s.length })[0];
    }

    // DE: maat altijd in cm ("45 cm")
    cm(l) { return `${l} cm`; }

    label() {
      const s = this.state;
      if (this.dataset.mode === 'silver') return `925 Silber · ${this.styleName(s.style)} · ${this.cm(s.length)}`;
      if (this.silver) return `925 Sterlingsilber · ${this.cm(s.length)}`;
      return `${this.fine(s.karat)} ${this.colorNames[s.color]} · ${this.styleName(s.style)} · ${this.cm(s.length)}`;
    }

    toggle(force) {
      const open = typeof force === 'boolean' ? force : this.panel.hidden;
      this.panel.hidden = !open;
      this.querySelectorAll('.mj-gc__change').forEach((b) => b.setAttribute('aria-expanded', open));
      this.classList.toggle('is-open', open);
      if (open) this.querySelector('[data-mj-gc-msg]').textContent = '';
    }

    openModal(id) {
      const d = this.querySelector('#' + CSS.escape(id));
      if (!d) return;
      // Aus einem offenen Fenster heraus (z. B. "Längenvergleich ansehen"): erst dieses schließen
      this.querySelectorAll('dialog[open]').forEach((o) => { if (o !== d) o.close(); });
      if (d.id.indexOf('MjGcStyleInfo') === 0) { this.tab = this.state.style; this.csingle = null; this.renderCompare(); }
      if (d.id.indexOf('MjGcLengthInfo') === 0) { this.lsingle = null; this.showLength(this.state.length); }
      if (typeof d.showModal === 'function') d.showModal(); else d.setAttribute('open', '');
      // Focus op het venster zelf, zodat iOS geen kader om het kruisje tekent
      d.focus({ preventScroll: true });
    }

    // Ketting toevoegen nadat de hanger via de hoofdknop in het mandje is gekomen
    addChain() {
      const v = this.current();
      if (!v) return;
      const label = this.label();
      const drawer = document.querySelector('cart-drawer');
      const sections = ['cart-icon-bubble'];
      if (drawer && drawer.getSectionsToRender) drawer.getSectionsToRender().forEach((x) => { if (!sections.includes(x.id)) sections.push(x.id); });
      const item = { id: v.id, quantity: 1 };
      if (this.dataset.pendant) item.properties = { 'Für': this.dataset.pendant };
      fetch(((window.routes && window.routes.cart_add_url) || '/cart/add') + '.js', {
        method: 'POST',
        keepalive: true, // loopt door als Globo de pagina meteen naar /cart stuurt
        headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-MJ-GC': '1' },
        body: JSON.stringify({ items: [item], sections: sections.join(','), sections_url: window.location.pathname })
      })
        .then((r) => r.json())
        .then((res) => {
          if (res.status) { this.chainNote(`${this.charm ? 'Das Armband' : 'Die Kette'} konnte nicht hinzugefügt werden: ${res.description || 'Bitte versuchen Sie es erneut.'}`, true); return; }
          const bubble = document.getElementById('cart-icon-bubble');
          if (bubble && res.sections && res.sections['cart-icon-bubble']) {
            const doc = new DOMParser().parseFromString(res.sections['cart-icon-bubble'], 'text/html');
            const inner = doc.querySelector('.shopify-section');
            if (inner) bubble.innerHTML = inner.innerHTML;
          }
          if (drawer && drawer.renderContents) { try { drawer.renderContents(res); } catch (e) {} }
          if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') publish(PUB_SUB_EVENTS.cartUpdate, { source: 'mj-gold-chain' });
          this.added = label;
          this.selected = false;
          this.checkEl.checked = false;
          this.toggle(false);
          this.render([]);
          // Het thema opent het "Added to cart"-venster niet altijd (fout in de sticky header); dan zelf openen
          const notif = document.querySelector('cart-notification');
          if (notif && !notif.classList.contains('active') && notif.open) { try { notif.open(); } catch (e) {} }
          // Aantal in "View my cart (n)" bijwerken
          fetch('/cart.js', { headers: { 'X-MJ-GC': '1' } }).then((r) => r.json()).then((c) => {
            const vb = document.getElementById('cart-notification-button');
            if (vb && c && typeof c.item_count === 'number') vb.textContent = vb.textContent.replace(/\(\d+\)/, `(${c.item_count})`);
          }).catch(() => {});
          this.chainNote(`+ ${this.itemName} · ${label} · ${this.money(v.price)}`);
        })
        .catch(() => this.chainNote(`${this.charm ? 'Das Armband' : 'Die Kette'} konnte nicht hinzugefügt werden. Bitte fügen Sie ${this.charm ? 'es' : 'sie'} erneut hinzu.`, true));
    }

    // Korte regel in het "Added to cart"-venster, zodat de klant ziet dat de ketting erbij zit
    chainNote(text, isError) {
      const put = () => {
        const host = document.querySelector('cart-notification #cart-notification-product') || document.querySelector('cart-notification .cart-notification-product');
        if (!host) return false;
        (host.parentElement || host).querySelectorAll('.mj-gc-note').forEach((x) => x.remove());
        const p = document.createElement('p');
        p.className = 'mj-gc-note' + (isError ? ' mj-gc-note--error' : '');
        p.textContent = text;
        host.after(p);
        return true;
      };
      if (!put()) setTimeout(put, 400);
      if (isError) { const m = this.querySelector('[data-mj-gc-msg]'); if (m) m.textContent = text; }
    }
  });
}
